'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var loader = require('./loader-8f6b1e8c.js');
var styles = require('./styles-a9f2fe66.js');

var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'button' : _b, text = _a.text, _c = _a.iconDirection, iconDirection = _c === void 0 ? 'right' : _c, dataCy = _a.dataCy, Icon = _a.Icon, loading = _a.loading, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, _e = _a.size, size = _e === void 0 ? 'm' : _e, _f = _a.disabledStyle, disabledStyle = _f === void 0 ? 'primary' : _f, _g = _a.multiline, multiline = _g === void 0 ? true : _g, isSkeleton = _a.isSkeleton, restProps = tslib_es6.__rest(_a, ["type", "text", "iconDirection", "dataCy", "Icon", "loading", "variant", "size", "disabledStyle", "multiline", "isSkeleton"]);
    return (React__default.createElement(styles.StyledButton, tslib_es6.__assign({ type: type, showIcon: !!Icon, showText: !!text, variant: variant, "data-cy": dataCy, size: size, disabledStyle: disabledStyle, loading: loading, isSkeleton: isSkeleton, role: "button" }, restProps),
        React__default.createElement(styles.ButtonContent, { className: "button-content", "data-testid": "button-content", iconDirection: iconDirection, loading: loading },
            text && React__default.createElement(styles.Text, { multiline: multiline, iconDirection: iconDirection, showIcon: !!Icon }, text),
            Icon),
        loading && (React__default.createElement(styles.LoaderContainer, null,
            React__default.createElement(loader.Loader, { size: 22, color: "currentColor" })))));
};

exports.Button = Button;
